import { isEmpty } from 'lodash';
import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as DeveloperActions from 'app/developer-v3/Actions';
import * as Profile from 'app/entities/Profile';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { parseBackendAppToAppFormType } from 'app/developer-v3/utils';
import {
  currentDefinitionOverride,
  selectZapTaskDetails,
} from 'app/developer-v3/selectors';

import VersionOverviewPage from './VersionOverviewPage';

const mapStateToProps = (state, props) => {
  const app = CliApp.selectors.all.entity(props.params.id, state);
  const definition = currentDefinitionOverride(state);
  const currentProfile = Profile.selectors.all.currentProfile(state);
  const integrationSettings = app.data
    ? parseBackendAppToAppFormType(app.data)
    : {};

  return {
    integrationSettings,
    isPrivate: CliApp.selectors.isPrivate(app),
    isStaff: Profile.selectors.isStaff(currentProfile),
    hasAuthentication: !isEmpty(definition.authentication),
    hasTriggers: !isEmpty(definition.triggers),
    hasActions: !isEmpty(definition.creates) || !isEmpty(definition.searches),
    zapTaskDetails: selectZapTaskDetails(state),
  };
};

const mapDispatchToProps = (dispatch, props) => ({
  onLoad() {
    dispatch(DeveloperActions.loadZapDetails());
  },
  async setIntentionPublic(integrationSettings) {
    await dispatch(
      DeveloperActions.updateApp(props.params.id, integrationSettings)
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(VersionOverviewPage));
